import { agent } from 'helpers';
import { ENV } from 'settings';

export const savePageLoad = (page: string, time: number) => () => {
  if (ENV !== 'production') {
    return null;
  }

  return agent.post('/healthcheck/pageload', {
    page,
    time_miliseconds: time,
    url: window.location.href,
  });
};
